import { axios } from "../axiosInstance";

export interface NewsFeedItem {
  html: string;
}

export interface NewsFeedPayload {
  lookup: string;
  unavailable: boolean;
  items: NewsFeedItem[];
}

export async function getNewsFeed(lookup: string): Promise<NewsFeedPayload> {
  const search = new URLSearchParams();
  if (lookup) {
    search.set("lookup", lookup);
  }
  const query = search.toString();
  const response = await axios.Get(`./newsFeeds${query ? `?${query}` : ""}`);
  return response.data as NewsFeedPayload;
}
